/* eslint-disable */
import { DropDown } from '@synergy-marine-group/synergy-ui';
import React from 'react';

const DropdownFieldComponent = ({
  field, // { name, value, onChange, onBlur }
  special = '',
  setFieldsNull,
  requiredField,
  isDynamic,
  isDisabled,
  isClearable,
  dependentfieldName,
  setChangedValue,
  customOnChange,
  customError,
  customTouched,
  dataObj = {},
  options,
  dependentfieldValue,
  form,
  ...props
}) => {
  const { touched, errors, setFieldValue } = form;

  const setcustomFieldValue = (
    fieldName,
    value,
    isDynamic = false,
    dependentfieldName,
    dependentfieldValue
  ) => {
    if (setChangedValue) setChangedValue(value);

    if (!isDynamic) {
      if (fieldName === 'expenseCategoryID') {
        setFieldValue('purposeID', '');
      }
    }

    if (isDynamic) {
      const accountCode = dependentfieldValue?.find((i) => i.value === value)?.accountCode;
      setFieldValue(dependentfieldName, accountCode);
    }

    if (setFieldsNull) {
      if (value !== field?.value) {
        setFieldsNull.forEach((element) => {
          setFieldValue(element, '');
        });
      }
    }

    setFieldValue(fieldName, value);
  };

  let selectedOption;
  if (dataObj?.expenseCategoryName === 'Safety Gear') {
    selectedOption = {
      label: dataObj?.expenseCategoryName,
      value: dataObj?.expenseCategoryId,
    };
  } else {
    selectedOption = options?.find(({ value }) => value === field.value)
      || (field.value != null && field.value !== ''
        ? options?.find(({ value }) => String(value).toLowerCase() === String(field.value).toLowerCase())
        : null)
      || special;
  }

  return (
    <div className={` ${requiredField ? 'required-field' : ''} ${isDisabled ? 'dropdown-disabled' : ''}`}>
      <DropDown
        {...field}
        {...props}
        options={options}
        isDisabled={isDisabled}
        value={selectedOption}
        filterOption={(option, rawInput) => {
          const labelText =
            option?.data?.searchLabel ||
            option?.label ||
            "";
      
          return labelText
            ?.toString()
            ?.toLowerCase()
            ?.includes(rawInput.toLowerCase());
        }}
        isClearable={isClearable}
        isSearchable
        onChange={(option) => {
          if (customOnChange) {
            customOnChange(option, form);
          } else {
            setcustomFieldValue(
              field.name,
              option?.value,
              isDynamic,
              dependentfieldName,
              dependentfieldValue
            );
          }
        }}
      />

      {touched[field.name] && errors[field.name] && (
        <div className="error text-xs">{errors[field.name]}</div>
      )}

      {customTouched && customError && (
        <div className="error text-xs absolute -bottom-4 ">{customError}</div>
      )}
    </div>
  );
};

export default DropdownFieldComponent;
